import { Loader2 } from "lucide-react";
import { Outlet } from "react-router";
import {
	type PermissionInput,
	usePermissions,
} from "@/hooks/use-permissions.ts";

export function RequirePermission({
	permission,
}: {
	permission: PermissionInput;
}) {
	const { has, isLoading } = usePermissions();

	if (isLoading) {
		return (
			<div className="route-loading">
				<Loader2 />
			</div>
		);
	}

	if (!has(permission)) {
		return (
			<div className="route-message">
				<p>Você não tem permissão para acessar esta seção.</p>
			</div>
		);
	}

	return <Outlet />;
}
